import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  background: transparent;\n  width: 24px;\n  height: 24px;\n  path {\n    &[stroke] {\n      stroke: ", ";\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  cursor: ", ";\n  ", "\n  margin-right: 10px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  height: 347px;\n  overflow: auto;\n  display: flex;\n  flex-direction: column-reverse;\n  padding: 20px 20px 0px;\n  background-color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 392px;\n  height: 500px;\n  max-width: 100%;\n  border-radius: ", "\n    ", " 0px 0px;\n  margin-left: auto;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 450px;\n  position: relative;\n  padding: 10px 0px 10px 20px;\n  border: none;\n  left: 0;\n  line-height: 50px;\n  border-radius: ", ";\n  background: none;\n  font-size: 14px;\n  &:focus {\n    outline-width: 0;\n    outline: none;\n  }\n  ::placeholder {\n    color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  height: 50px;\n  display: flex;\n  background-color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 0px 0px ", "\n    ", ";\n  background-color: ", ";\n  padding: 10px 20px 20px;\n  margin-top: -1px;\n  @media screen and (max-width: ", "px) {\n    border-radius: 0px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { useMutation } from '@apollo/react-hooks';
import { AcornsIcon } from '@acorns/icons';
import { useRemoteStrings } from '../../utils/providers/remoteStrings';
import askQuestionMutation from './mutations/askQuestion.gql';
import rateResponseMutation from './mutations/rateResponse.gql';
import { AI_CHAT_INPUT, AI_CHAT_SEND_CTA } from './testIDs';
import { TypingDots } from './TypingDots';
import { SentMessage } from './SentMessage';
import { ResponseMessage } from './ResponseMessage';
import { MessagesHeader } from './MessagesHeader';
var InputContainer = styled.div(_templateObject(), function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.colors.cloud;
}, function (props) {
  return props.theme.breakpoints.sm;
});
var InnerInputContainer = styled.div(_templateObject2(), function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.colors.white;
});
var ChatInput = styled.input(_templateObject3(), function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.colors.stone;
});
var ChatContainer = styled.div(_templateObject4(), function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.borderRadius.large;
});
var MessagesContainer = styled.div(_templateObject5(), function (props) {
  return props.theme.colors.cloud;
});
var SubmitButton = styled.button(_templateObject6(), function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.disabled && 'opacity: 0.2;';
});
var SendIcon = styled(AcornsIcon)(_templateObject7(), function (props) {
  return props.theme.colors.slate;
});

var AIAssistant = function AIAssistant(_ref) {
  var showAIAssistant = _ref.showAIAssistant,
      setShowAIAssistant = _ref.setShowAIAssistant;

  var _useRemoteStrings = useRemoteStrings(),
      getRemoteString = _useRemoteStrings.getRemoteString;

  var initialMessage = {
    type: 'responseMessage',
    text: getRemoteString({
      key: 'ai_assistant.chat.initial_message'
    }),
    rating: 0
  };

  var _useState = useState([initialMessage]),
      _useState2 = _slicedToArray(_useState, 2),
      messages = _useState2[0],
      setMessages = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      input = _useState4[0],
      setInput = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      botIsTyping = _useState6[0],
      setBotIsTyping = _useState6[1];

  var _useMutation = useMutation(rateResponseMutation),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      rateResponse = _useMutation2[0];

  var _useState7 = useState(uuidv4()),
      _useState8 = _slicedToArray(_useState7, 1),
      sessionId = _useState8[0];

  var addMessage = function addMessage(message) {
    var newMessage = _objectSpread(_objectSpread({}, message), {}, {
      rating: 0
    });

    setMessages(function (prevMessages) {
      return [newMessage].concat(_toConsumableArray(prevMessages));
    });
  };

  var _useMutation3 = useMutation(askQuestionMutation, {
    onCompleted: function onCompleted(data) {
      var result = data.askFinancialAdvisorQuestion.message;
      var interactionId = data.askFinancialAdvisorQuestion.interactionId;
      var responseMessage = {
        type: 'responseMessage',
        text: result,
        interactionId: interactionId,
        rating: 0
      };
      setBotIsTyping(false);
      addMessage(responseMessage);
    },
    onError: function onError() {
      setBotIsTyping(false);
      var responseMessage = {
        type: 'responseMessage',
        text: getRemoteString({
          key: 'ai_assistant.chat.error_message'
        }),
        isError: true
      };
      addMessage(responseMessage);
    }
  }),
      _useMutation4 = _slicedToArray(_useMutation3, 1),
      askChatbot = _useMutation4[0];

  var handlePost = function handlePost() {
    var sentMessage = {
      type: 'sentMessage',
      text: input
    };
    addMessage(sentMessage);
    setInput('');
    setBotIsTyping(true);
    askChatbot({
      variables: {
        question: input,
        sessionId: sessionId
      }
    });
  };

  var handleRateResponse = function handleRateResponse(interactionId, givenRating) {
    setMessages(messages.map(function (message) {
      if (message.interactionId === interactionId) {
        return _objectSpread(_objectSpread({}, message), {}, {
          rating: givenRating
        });
      } else {
        return message;
      }
    }));
    rateResponse({
      variables: {
        interactionId: interactionId || 'default',
        rating: givenRating
      }
    });
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter' && !botIsTyping) {
      handlePost();
    }
  };

  return showAIAssistant ? /*#__PURE__*/React.createElement(ChatContainer, null, /*#__PURE__*/React.createElement(MessagesHeader, {
    setShowAIAssistant: setShowAIAssistant
  }), /*#__PURE__*/React.createElement(MessagesContainer, null, botIsTyping && /*#__PURE__*/React.createElement(TypingDots, null), messages.map(function (message, index) {
    return message.type === 'sentMessage' ? /*#__PURE__*/React.createElement(SentMessage, {
      key: index,
      index: index,
      message: message
    }) : /*#__PURE__*/React.createElement(ResponseMessage, {
      key: index,
      index: index,
      message: message,
      handleRateResponse: handleRateResponse
    });
  })), /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(InnerInputContainer, null, /*#__PURE__*/React.createElement(ChatInput, {
    "data-testid": AI_CHAT_INPUT,
    value: input,
    placeholder: getRemoteString({
      key: 'ai_assistant.input.placeholder'
    }),
    onChange: function onChange(e) {
      setInput(e.target.value);
    },
    onKeyDown: handleKeyDown
  }), /*#__PURE__*/React.createElement(SubmitButton, {
    disabled: botIsTyping || input.length === 0,
    "data-testid": AI_CHAT_SEND_CTA,
    onClick: botIsTyping ? undefined : handlePost
  }, /*#__PURE__*/React.createElement(SendIcon, {
    icon: AcornsIcon.Icon.UtilityArrowRight
  }))))) : /*#__PURE__*/React.createElement(React.Fragment, null);
};

export { AIAssistant };